<template>
  <div class="dictionary-base">
    <data-table ref="dataTable" :option="option">
      <template #headAction v-if="code == 'RoomType'">
        <a-button type="primary" style="margin-left:10px" @click="addRoomPic"
          >添加房型图片</a-button
        >
      </template>
    </data-table>
    <AddRoomPic ref="AddRoomPic"></AddRoomPic>
  </div>
</template>

<script>
import { DataTable } from "@/components/dataTable";
import AddRoomPic from "./AddRoomPic";
import { cache } from "@/utils/common";
export default {
  components: {
    DataTable,
    AddRoomPic
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    },
    code: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      option: {},
      apiOptions: {},
      extendData: "",
      user: null
    };
  },
  watch: {
    data(val) {
      if (val.treeSelect) {
        this.init(val);
      }
    }
  },
  created() {
    this.user = cache.get("user");
    this.option = {
      form: {
        title: "",
        width: 900,
        content: []
      },
      grid: {}
    };
    this.init(this.data);
  },
  methods: {
    //初始化函数，用于初始化
    init(Data) {
      const _this = this;
      if (!this.data.treeSelect) {
        return;
      }
      let listApi = "MaintenanceType_List";
      if (this.user.IsGroupSystem) {
        listApi = "Group_MaintenanceType_List";
      }
      _this.$post(listApi).then(res => {
        //存储左侧树类型，用于新增编辑
        _this.extendData = Data.treeSelect;

        //拿取系统维护树的全部组合方式数据源
        const ListData = res.Data;

        //根据当前树被选择对象拿取系统维护树中对应的项参数
        const checkItemIndex = ListData.findIndex(
          item => item.Name === Data.treeSelect
        );

        //统一设置全部api
        _this.apiOptions = {
          api: "MaintenancePage_List",
          params: { Type: Data.treeSelect },
          addApi: "Maintenance_Add",
          getApi: "Maintenance_Get",
          editApi: "Maintenance_Edit",
          delApi: "Maintenance_Del"
        };
        if (this.user.IsGroupSystem) {
          _this.apiOptions = {
            api: "Group_MaintenancePage_List",
            params: { Type: Data.treeSelect },
            addApi: "Group_Maintenance_Add",
            getApi: "Group_Maintenance_Get",
            editApi: "Group_Maintenance_Edit",
            delApi: "Group_Maintenance_Del"
          };
        }
        //编辑弹窗接口及其相关设置
        _this.option.form.edit = {
          infoApi: _this.apiOptions.getApi,
          submitApi: _this.apiOptions.editApi,
          onSubmitBefore: values => {
            values.Type = _this.extendData;
            return values;
          }
        };

        //根据特殊模式变量设置是否出现新增删除按钮
        if (Data.specialMode == true) {
          delete _this.option.form.add;
          delete _this.option.form.del;
        } else {
          let sort = 0;
          if (ListData[checkItemIndex].Name == "Floor") {
            sort = 1;
          }
          _this.option.form.add = {
            submitApi: _this.apiOptions.addApi,
            onOpenAfter: () => {
              let values = { Status: "1", Sort: sort };
              return values;
            },
            onSubmitBefore: values => {
              values.Type = _this.extendData;
              return values;
            }
          };
          _this.option.form.del = {
            submitApi: _this.apiOptions.delApi,
            onSubmitBefore: values => {
              return values;
            }
          };
        }

        const gridTable = _this.option.grid;

        //声明表格内容容器和表单内容容器
        const gridColums = [
          {
            title: "序号",
            width: "50px", //宽度
            align: "center", //对齐方式
            type: "indexcolumn" // 类型，indexcolumn = 序号
          }
        ];
        var formContent = [];

        gridTable.api = _this.apiOptions.api;
        gridTable.params = _this.apiOptions.params;

        const checkItem = ListData[checkItemIndex];
        _this.option.form.title = checkItem && checkItem.DisplayName;

        const fields = checkItem.Fields;
        if (this.code == "RoomType") {
          //房型添加简称
          fields.splice(fields.length - 2, 0, {
            DictionaryFieldType: 0,
            DisplayName: "简称",
            Name: "Backup01",
            Readonly: false,
            Required: false,
            Show: true
          });
        }
        //枚举字典，用于判别表单各项的类型
        const inputs = {
          0: "input",
          1: "textarea",
          2: "number",
          3: "number",
          4: "time",
          5: "date",
          6: "select",
          7: "checkbox-group"
        };

        //根据ListData和checkItemIndex拼接表格和表单内容
        if (checkItem.Name == "RoomType") {
          [fields[5], fields[6]] = [fields[6], fields[5]];
          _this.option.grid.props = {
            scroll: {
              x: 1200,
              y: 357
            }
          };
        }
        for (let i = 0; i < fields.length; i++) {
          const field = fields[i];

          //描述框禁止输入
          if (field.DisplayName == "描述") {
            _this.lockUp = true;
          } else {
            _this.lockUp = false;
          }
          var formItem = {
            label: field.DisplayName,
            name: field.Name,
            type: inputs[field.DictionaryFieldType],
            isStopTab: field.DictionaryFieldType == 1,
            props: {
              disabled: _this.lockUp
            }
          };
          if (field.DictionaryFieldType == 3) {
            formItem.props.precision = 2;
          }
          var gridItem = {};
          //字典项6：下拉框
          if (field.DictionaryFieldType == 6) {
            formItem.api = this.$config.serverUrl + field.ComboBoxUrl;
            formItem.param = { types: field.ComboBoxParams.Types };
            formItem.dataField = "Data." + field.ComboBoxParams.Types;

            formItem.option = {
              rules: [{ required: field.Required }]
            };
            if (field.Show == true) {
              gridItem = {
                title: field.DisplayName,
                width: 120,
                dataIndex: field.ComboBoxParams.Types + "Name",
                align: "center"
              };
            }
          }
          //字典项2：数字输入框
          else if (field.DictionaryFieldType == 2) {
            formItem.min = 0;
            if (field.Show == true) {
              gridItem = {
                title: field.DisplayName,
                dataIndex: field.Name,
                align: "center",
                width: 100,
                customRender: text => {
                  if (field.Name == "BackupInt02") {
                    return !text ? 0 : text;
                  }
                  return text;
                }
              };
            }
          } else {
            if (field.DictionaryFieldType == 1) {
              formItem.colnum = 2;
            }
            if (field.Show == true) {
              gridItem = {
                title: field.DisplayName,
                dataIndex: field.Name,
                align: "center",
                width: 120
              };
              if (field.DictionaryFieldType == 1) {
                // gridItem.tooltip = true;
                gridItem.width = "";
                gridItem.align = "left";
              }
            }
          }
          gridColums.push(gridItem);
          formContent.push(formItem);
        }
        const control = {
          title: "操作",
          dataIndex: "Id",
          key: "action",
          align: "center",
          width: 150,
          scopedSlots: { customRender: "rowAction" } //插槽 ，rowAction 默认的 编辑、删除 操作按钮插槽，如需其它按钮需自行定义插槽
        };
        _this.option.grid.props = {
          scroll: {
            y: window.document.body.clientHeight - 300
          }
        };
        gridColums.push(control);
        _this.option.grid.columns = gridColums;
        _this.option.grid.props = {
          scroll: {
            x: (_this.option.grid.columns.length - 1) * 120 + 200,
            y: "calc(100vh - 300px)"
          }
        };
        this.$refs.dataTable.updateFormContent("", "", formContent);
      });
    },
    addRoomPic() {
      const row = this.$refs.dataTable.getSelected();
      if (!row) {
        this.$message.info("请选择房型");
        return false;
      }
      this.$refs.AddRoomPic.show(row);
    }
  }
};
</script>

<style></style>
